//// Application Packages
import React from 'react'

//// Application Slices

//// Application Components

//// Carbon Components
import {
    InlineNotification,
    NotificationActionButton,
    ToastNotification,
} from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const NotificationComponent = ({
    notification: { type, visible, kind, caption, subtitle, timeout, title },
}) => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    // Notification Style Object
    const ntfStyObj = {}

    // Notification Style - Visible
    if (visible) {
        ntfStyObj.visible = visible
    } else {
        ntfStyObj.timeout = false
    }

    // Notification Style - Kind
    if (kind) {
        ntfStyObj.kind = kind
    } else {
        ntfStyObj.kind = 'success'
    }

    // Notification Style - Caption
    if (caption) {
        ntfStyObj.caption = caption
    } else {
        ntfStyObj.caption = ''
    }

    // Notification Style - Timeout
    if (timeout) {
        ntfStyObj.timeout = timeout
    } else {
        ntfStyObj.timeout = 0
    }

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (type === 'toast' && visible && title && subtitle) {
        return (
            <>
                <div className="fldoh-notification-toast-group">
                    <ToastNotification
                        className="fldoh-notification-toast"
                        caption={ntfStyObj.caption}
                        iconDescription="Close & Exit Notification"
                        subtitle={subtitle}
                        timeout={timeout}
                        title={title}
                        kind={ntfStyObj.kind}
                        role="alert"
                    />
                </div>
            </>
        )
    } else if (type === 'inline' && visible && title && subtitle) {
        return (
            <>
                <div className="fldoh-notification-inline-group">
                    <InlineNotification
                        className="fldoh-notification-inline"
                        actions={
                            <NotificationActionButton>
                                Action
                            </NotificationActionButton>
                        }
                        iconDescription="Close & Exit Notification"
                        subtitle={<span>{subtitle}</span>}
                        title={title}
                        kind={ntfStyObj.kind}
                        role="alert"
                    />
                </div>
            </>
        )
    } else {
        return <></>
    }
}

export default NotificationComponent
